<h2>Selectati furnizorul pentru care aveti conflict de interese:</h2>
<dx-form [formData]="ic.model">
    <dxi-item [label]="{text: L('SUPPLIER')}" dataField="partyId" editorType="dxSelectBox"
        [editorOptions]="{ dataSource: ic.dsSupplier, valueExpr: 'rp_partyId', displayExpr: 'p_name' }"></dxi-item>
</dx-form>